import React, { useRef, useEffect } from 'react';
import { Button, Tooltip, Divider } from 'antd';
import {
  BoldOutlined, ItalicOutlined, UnderlineOutlined,
  UnorderedListOutlined, OrderedListOutlined, ClearOutlined,
} from '@ant-design/icons';
import './RichTextEditor.css';

// Minimal rich-text editor built on contentEditable (no extra dependency).
// Controlled via value (HTML) / onChange — works inside antd Form.Item.
const RichTextEditor = ({ value = '', onChange, placeholder = 'Write something…', minHeight = 120 }) => {
  const ref = useRef(null);

  // Sync external value only when it differs (avoids caret jumps while typing)
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || '')) {
      ref.current.innerHTML = value || '';
    }
  }, [value]);

  const emit = () => onChange && onChange(ref.current.innerHTML === '<br>' ? '' : ref.current.innerHTML);
  const exec = (cmd) => { document.execCommand(cmd, false, null); ref.current.focus(); emit(); };

  const btn = (icon, cmd, title) => (
    <Tooltip title={title}>
      <Button type="text" size="small" icon={icon}
        onMouseDown={(e) => e.preventDefault()} onClick={() => exec(cmd)} />
    </Tooltip>
  );

  return (
    <div className="rte-wrap">
      <div className="rte-toolbar">
        {btn(<BoldOutlined />, 'bold', 'Bold')}
        {btn(<ItalicOutlined />, 'italic', 'Italic')}
        {btn(<UnderlineOutlined />, 'underline', 'Underline')}
        <Divider type="vertical" />
        {btn(<UnorderedListOutlined />, 'insertUnorderedList', 'Bullet list')}
        {btn(<OrderedListOutlined />, 'insertOrderedList', 'Numbered list')}
        <Divider type="vertical" />
        {btn(<ClearOutlined />, 'removeFormat', 'Clear formatting')}
      </div>
      <div
        ref={ref}
        className="rte-content"
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder}
        style={{ minHeight }}
        onInput={emit}
        onBlur={emit}
      />
    </div>
  );
};

export default RichTextEditor;
